import React from 'react';
import PropTypes from 'prop-types';

import _ from 'helpers/no_conflict_lodash';

import { ControlLabel, FormControl, FormGroup } from 'react-bootstrap';

export default class FilterSelect extends React.Component {
  static propTypes = {
    ...FormControl.propTypes,
    defaultValue: PropTypes.any,
    label: PropTypes.string,
    options: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.any,
      value: PropTypes.any,
      label: PropTypes.any
    }))
  };

  render() {
    const { label } = this.props;
    return (
      <FormGroup>
        <ControlLabel>{label}</ControlLabel>
        {this.renderSelect()}
      </FormGroup>
    );
  }

  renderSelect() {
    const { label, options, placeholder, ...otherProps } = this.props;
    return <FormControl componentClass="select" {...otherProps}>
      {placeholder && this.renderDefaultOption(placeholder)}
      {this.renderOptions(options || [])}
    </FormControl>;
  }

  renderOptions(options) {
    return _.map(options, option => (
      <option key={option.id} value={option.value}>{option.label}</option>
    ));
  }

  renderDefaultOption(label) {
    return <option key={this.props.defaultValue} value={this.props.defaultValue}>{label}</option>;
  }
}
